import { appRoutes } from 'consts/paths/paths';

export const IGNORED_BASE = appRoutes.app.base;
export const OFFSET_FOR_PATH = 1;
export const OFFSET_FOR_SNIPPETS_WITH_BASE = 2;
